import wrappedFetch from './base';

export const createUsersDemos = (demoId) => {
  const config = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ demo_id: demoId })
  };
  return wrappedFetch('/users_demos/create', config)
    .then((response) => response.json());
};

export const resetCreateUsersDemos = async (pageName) => {
  const config = {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ page_name: pageName })
  };
  return wrappedFetch('/users_demos/reset', config)
    .then((response) => response.json());
};
